import React from 'react';
import {useTranslation} from 'react-i18next';
import {useSelector} from 'react-redux';
import {FLIP_CARD_SIDE, IElementFlipCard} from '../../../incase-domain/elements/flipCard';
import FlipCardElement from './flipCardElement';
import {DeviceType} from '../../../incase-domain/common/DeviceType.enum';
import {getFlipCardSide} from '../../../store/selectors/flipCard.selector';
import {AppState} from '../../../store/reducer';

interface ElementFlipCardComponentProps {
    element: IElementFlipCard;
    device?: DeviceType;
}

export default function ElementFlipCardComponent(props: ElementFlipCardComponentProps): JSX.Element {
    const {element, device = DeviceType.DESKTOP} = props;
    const facingSide = useSelector((state: AppState) => getFlipCardSide(state, element.id));
    const {t} = useTranslation();

    return (
        <>
            <div className={`c-flipCardElement ${facingSide === FLIP_CARD_SIDE.BACK && 'is-flipped'}`}>
                <div
                    className={
                        device === DeviceType.DESKTOP
                            ? 'c-flipCardElement__inner'
                            : 'c-flipCardElement__inner c-flipCardElement__inner_mobile'
                    }
                >
                    <div className="c-flipCardElement__inner_front">
                        {(element as IElementFlipCard).flipCardElement && (element as IElementFlipCard).flipCardElement.FRONT ? (
                            <FlipCardElement
                                element={element}
                                flipCardSide={FLIP_CARD_SIDE.FRONT}
                                type={element.flipCardElement.FRONT.type}
                                device={device}
                            />
                        ) : (
                            <h3>{t('flipCard.frontSide')}</h3>
                        )}
                    </div>
                    <div className="c-flipCardElement__inner_back">
                        {(element as IElementFlipCard).flipCardElement && (element as IElementFlipCard).flipCardElement.BACK ? (
                            <FlipCardElement
                                element={element}
                                flipCardSide={FLIP_CARD_SIDE.BACK}
                                type={element.flipCardElement.BACK.type}
                                device={device}
                            />
                        ) : (
                            <h3>{t('flipCard.backSide')}</h3>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
}
